import {
  convertUnixTimeToDate,
  convertDatetoReadableFormat,
} from "core/utils/dateTimeUtils";
import {
  getOCSFSeverityNameFromNumber,
} from "core/utils/common";

import { IRowProps } from 'core/components/global/tables/datagrid/dataGrid.type';

export const getAlertsResponseMapper = (t, data): IRowProps[] => {
  // Check if data is an array
  if (!Array.isArray(data)) {
    console.error("Data is not an array:", data);
    return [];
  }
  
  try {
    const temp = data.map((finding) => {
      // Make sure finding is an array before accessing by index
      if (!Array.isArray(finding)) {
        console.error("Finding is not an array:", finding);
        // Instead of returning null, return a minimal valid object
        return {
          id: 'unknown',
          severity: t("SEVERITY.UNCLASSIFIED"),
          classification: '',
          org: '',
          assignedto: '',
          createdDate: '',
          latestKeyEvent: '',
          status: '',
          framework: '',
          rule: '',
          resourceids: {},
          alertname: '',
          findingId: '',
          passfail: '',
          provider: ''
        };
      }

      // Handle severity conversion more robustly
      let severity;
      if (typeof finding[1] === 'number') {
        severity = getOCSFSeverityNameFromNumber(t, finding[1]);
      } else {
        // If severity is not a number, use a default value
        console.warn("Severity is not a number:", finding[1]);
        severity = t("SEVERITY.UNCLASSIFIED");
      }

      const response =  {
        id: finding[0],
        severity: severity,
        classification: finding[2],
        org: finding[3],
        assignedto: finding[4],
        createdDate: convertUnixTimeToDate(finding[5]),
        latestKeyEvent: convertDatetoReadableFormat(finding[6]),
        status: finding[7],
        framework: finding[8],
        rule: finding[9],
        resourceids: finding[10],
        alertname: finding[11],
        // Added missing fields
        findingId: finding[12],
        passfail: finding[13],
        provider: finding[14],
        // Extract tags from the last element if it exists
        tags: finding[15]?.tags || []
      };
      console.log('Mapped row with tags:', response);
      return response;
    });
  
    return temp;
    
  } catch (error) {
    return [];
  }
};